var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{attrs:{"datetime":_vm.time,"title":_vm.localeDateString}},[_vm._v("\n  "+_vm._s(_vm.$t(_vm.relativeTime.key, [_vm.relativeTime.num]))+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }